export enum FileUploadMode {
  SingleFileSingleUpload = 0,
  SingleFileMultipleUpload = 1
}
